// import { default as Mui5Button } from '@mui/material/Button'
import { Button } from '../core'
import { LoadingDots } from '../core/LoadingDots'
import { styled } from '../styles/styled'
import { getHighlightButtonStyles, textColorOnHighlightBackground } from './highlightButtonStyles'

const TransactionLabel = styled('div')(({ theme }) => {
  return {
    wordBreak: 'break-word',
    flexGrow: 1,
    padding: 0,
  }
})

const TransactionLabelWrapper = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
  }
})

type TransactionButtonProps = {
  highlightColor?: string
}

const TransactionButton = styled(Button)<TransactionButtonProps>(
  ({ theme, highlightColor }) => {
    const trimmed = highlightColor?.trim()
    return {
      height: 'unset',
      minHeight: 40,
      alignItems: 'center',
      display: 'flex',
      overflow: 'auto',
      padding: 5,
      wordWrap: 'break-word',
      width: 'calc(100% - 2px)',
      letterSpacing: 'normal',
      ...(trimmed ? getHighlightButtonStyles(theme, trimmed) : {}),
    }
  },
  {
    shouldForwardProp: (prop) => prop !== 'highlightColor',
  }
)

export const TransactionActionButton = ({
  isLoading,
  label,
  disabled,
  onClick,
  highlightColor,
}: {
  isLoading: boolean
  label: React.ReactNode
  disabled: boolean
  onClick?(): void
  /** Org brand colour — when set, replaces default green success styling. */
  highlightColor?: string
}) => {
  const trimmedHighlight = highlightColor?.trim()
  const loadingDotsColor = trimmedHighlight ? textColorOnHighlightBackground(trimmedHighlight) : '#fff'

  return (
    <TransactionButton
      disabled={disabled}
      highlightColor={trimmedHighlight}
      onClick={(e) => {
        e.preventDefault()
        if (isLoading || disabled) return
        onClick?.()
      }}
      color={trimmedHighlight ? 'secondary' : 'success'}
      variant="contained"
    >
      {isLoading ? (
        <LoadingDots color={loadingDotsColor} />
      ) : (
        <TransactionLabelWrapper>
          <TransactionLabel>{label}</TransactionLabel>
        </TransactionLabelWrapper>
      )}
    </TransactionButton>
  )
}

export default TransactionActionButton
